export class DOCUMENT_TAG {
  static readonly PatientPicture:string = '0000001D-1000-0000-0000-000000000001';
  static readonly PreOp:string =          '0000001d-1000-0000-0000-000000000008';
  static readonly PostOp:string =         '0000001D-1000-0000-0000-000000000014';
  static readonly General:string =         '0000001D-1000-0000-0000-000000000090';
  static readonly CopyofPatientInsuranceCard:string =  '0000001D-1000-0000-0000-000000000045';
  static readonly InsuranceCheck:string =  '0000001D-1000-0000-0000-000000000066';
  static readonly InsuranceEOB:string =  '0000001D-1000-0000-0000-000000000067';
  }